export const topBarHeight = 64;
export const sideNavWidth = 260;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;

export const enquiryStatusOptions = [
  { label: "New", value: "New" },
  { label: "In Progress", value: "InProgress" },
  { label: "Resolved", value: "Resolved" }
];

export const enquiryStatusFilterOptions = [
  { label: "All", value: "all" },
  ...enquiryStatusOptions
];

export const statusOptions = [
  { label: "All", value: "all" },
  { label: "Active", value: true },
  { label: "In-Acitve", value: false }
];

export const ROUTES = {
  META_INFO: "/meta-info",
  ADD_META_INFO: "/meta-info/add",
  BLOG: "/blog",
  BLOG_CATEGORY: "/blog-category",
  CAREER: "/careers",
  CLIENTS: "/enquiry",
  META: "/meta-info",
  FAQ: "/faq",
  REFERALS: "/referals",
  REFERALSDATA: "/referal-data"
};

export const DEFAULT_PER_PAGE = 10;
export const DEFAULT_FILTER = {
  skip: 0,
  limit: DEFAULT_PER_PAGE
};
